import React from 'react'
import './_style.scss';
// Components
import ImageText from '§/src/components/sections/image-text';

const Rules = (props) => {
    const {
        titolo,
        testo,
        image,
        rules = [],
        rulesOffset = 0,
        hasIntro,
        ...rulesProps
    } = props.data || {};

    const rulesIntroImgText = {
        titolo: titolo,
        testo: testo,
        image: image,
        classeTitolo: "intro-img-text-title",
        classeTesto: "intro-img-text-content",
        reverse: true
    }

    const compClassName = 'rules';
    const compClass = props?.className !== undefined ? compClassName + ' ' + props?.className : compClassName;

    // Ensure rules array exists
    if (!Array.isArray(rules)) {
        console.error('Rules component expects rules to be an array');
        return null;
    }

    return (
        <div comp={compClassName} className={compClass}>
            <div className='container'>
                <div className="waves">
                    <div></div>
                </div>
                {hasIntro && (
                    <ImageText data={rulesIntroImgText} />
                )}
                <div className={'d-flex align-items-start flex-column flex-md-row rules-container'}>
                    {/* Rule 1 */}
                    <div className='col'>
                        {!hasIntro && (
                            <div className="waves">
                                <div></div>
                            </div>
                        )}
                        <h2>{rulesOffset + 1 + '.'}</h2>
                        {rules[rulesOffset] && (
                            <>
                                <h2>{rules[rulesOffset].titoloRegola}</h2>
                                <p dangerouslySetInnerHTML={{ __html: rules[rulesOffset].contenutoRegola }}></p>

                            </>
                        )}
                    </div>

                    {/* Rule 2 */}
                    <div className='col'>
                        <div className="waves">
                            <div></div>
                        </div>
                        <h2>{rulesOffset + 2 + '.'}</h2>
                        {rules[rulesOffset + 1] && (
                            <>
                                <h2>{rules[rulesOffset + 1].titoloRegola}</h2>
                                <p dangerouslySetInnerHTML={{ __html: rules[rulesOffset + 1].contenutoRegola }}></p>
                            </>
                        )}
                    </div>

                    {/* Rule 3 */}
                    <div className='col'>
                        <div className="waves">
                            <div></div>
                        </div>
                        <h2>{rulesOffset + 3 + '.'}</h2>
                        {rules[rulesOffset + 2] && (
                            <>
                                <h2>{rules[rulesOffset + 2].titoloRegola}</h2>
                                <p dangerouslySetInnerHTML={{ __html: rules[rulesOffset + 2].contenutoRegola }}></p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rules;
